import React from 'react'
import { Container } from '@mui/material'
import Layout from 'components/Layout/Layout'
import MenuTab from 'components/MenuTab/Index'

const YourTabSkeleton = () => {
  return (
    <>
      <Layout title="Your Table | FasTab">
        <section className="wrapper with-footer">
          <Container maxWidth="md">
            {/* Keep the actual MenuTab header - it stays the same */}
            <MenuTab yourTab />

            {/* Only skeleton the content area */}
            <div className="card mb-50">
              <div style={{ padding: '20px' }}>
                {/* Simple header skeleton for table details */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px',
                  }}
                >
                  <div
                    className="skeleton-text"
                    style={{ width: '100px', height: '20px' }}
                  />
                  <div
                    className="skeleton-text"
                    style={{ width: '60px', height: '16px' }}
                  />
                </div>

                {/* Simple content skeleton for orders */}
                <div style={{ marginBottom: '20px' }}>
                  {[1, 2, 3].map((index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: '15px',
                        padding: '15px',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '8px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: '10px',
                        }}
                      >
                        <div
                          className="skeleton-text"
                          style={{ width: '150px', height: '16px' }}
                        />
                        <div
                          className="skeleton-text"
                          style={{ width: '80px', height: '16px' }}
                        />
                      </div>
                      <div
                        className="skeleton-text"
                        style={{ width: '200px', height: '14px' }}
                      />
                    </div>
                  ))}
                </div>

                {/* Simple summary skeleton */}
                <div
                  style={{ borderTop: '1px solid #e0e0e0', paddingTop: '15px' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: '8px',
                    }}
                  >
                    <div
                      className="skeleton-text"
                      style={{ width: '80px', height: '14px' }}
                    />
                    <div
                      className="skeleton-text"
                      style={{ width: '60px', height: '14px' }}
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: '8px',
                    }}
                  >
                    <div
                      className="skeleton-text"
                      style={{ width: '50px', height: '14px' }}
                    />
                    <div
                      className="skeleton-text"
                      style={{ width: '50px', height: '14px' }}
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontWeight: 'bold',
                    }}
                  >
                    <div
                      className="skeleton-text"
                      style={{ width: '60px', height: '18px' }}
                    />
                    <div
                      className="skeleton-text"
                      style={{ width: '70px', height: '18px' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Container>

          {/* Footer skeleton in footer's place */}
          <footer className="footer mui-fixed">
            <Container maxWidth="md">
              <div
                style={{
                  padding: '10px 0',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <div
                  className="skeleton-text"
                  style={{ width: '200px', height: '16px' }}
                />
                <div
                  className="skeleton-text"
                  style={{
                    width: '280px',
                    height: '48px',
                    borderRadius: '24px',
                  }}
                />
              </div>
            </Container>
          </footer>
        </section>
      </Layout>
    </>
  )
}

export default YourTabSkeleton
